// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageItemContainer {
    display: flex;
    width: 300px;
    height: 280px;
    margin: 20px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    border-radius: 10px;
    background-color: #ffffff;
    /* box-shadow: 2px 2px 12px rgb(180 180 180 / 64%); */

}

.MessagePageContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #f1f7ff;

}

.newMsg-Btn {
    margin: 20px;
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    border-radius: 10px;
    color: white;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    border: none;
    width: 10%;
    font-weight: 500;
    font-size: 10pt;
    color: #ffffff;
}

.newMsgSubmit-Btn {
    margin: 20px;
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    border-radius: 10px;
    color: white;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    border: none;
    width: 30%;
    font-weight: 500;
    font-size: 10pt;
    color: #ffffff;
}

.message-modal {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 40%;
    border-radius: 20px;
    box-shadow: 2px 2px 12px rgb(180 180 180 / 64%);

}

.message-modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.messagesIcons {
    display: flex;
}

.messagesActions {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.action-btn {
    margin: 8px;
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    text-align: center;
    background-size: 200% auto;
    border-radius: 100px;
    border: none;
    color: white;
    padding: 11px;
    font-weight: 500;
    font-size: 10pt;


}

.messageActivity-btn {
    margin: 8px;
    text-align: center;
    background-color: white;
    border-radius: 100px;
    border: 1px solid #3762f0;
    padding: 11px;
    font-weight: 500;
    font-size: 10pt;
    display: flex;
    align-items: center;
}

.messageActivity-btn:hover {

    background-color: rgb(239, 239, 255);


}

.action-btn {
    border-radius: 100px;
    padding: 9px;

}

.form-group {
    display: flex;
    flex-direction: column;
}

.messageContent {
    margin-bottom: 20px;
    background-color: #f1f1f1;
    padding: 20px;
    width: 80%;
    height: 80%;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;


}

.allMessagesContainer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    height: 80%;
    width: 80%;

}

.chooseActivity {
    margin: 5px;
}

.chooseActivityCont {
    margin: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
}

.chooseActivityCont div {
    margin: 10px;

}

.close:hover {
    cursor: pointer;
}

.updateBtnsContainer {
    display: flex;
}

.updateBtns {
    background-color: white;
    border: 1px solid #3762f0;
    padding: 7px;
    border-radius: 100px;
    margin: 10px;
    width:120px;
}

.messageContentInput {
    margin-bottom: 20px;
    background-color: #ffffff;
    padding: 20px;
    width: 100%;
    height: 80%;
    border-radius: 20px;
    display: flex;
    border: none;
}

.titleAndNewMessage{
    margin-top: 7%;
    width: 100%;

}`, "",{"version":3,"sources":["webpack://./src/components/Messages/MessagePage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,qDAAqD;;AAEzD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;;AAE7B;;AAEA;IACI,YAAY;IACZ,kFAAkF;IAClF,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kFAAkF;IAClF,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,mBAAmB;IACnB,+CAA+C;;AAEnD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kFAAkF;IAClF,kBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;;;AAGnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,oCAAoC;;;AAGxC;;AAEA;IACI,oBAAoB;IACpB,YAAY;;AAEhB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;;AAG3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,UAAU;;AAEd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;;AAEf","sourcesContent":[".MessageItemContainer {\r\n    display: flex;\r\n    width: 300px;\r\n    height: 280px;\r\n    margin: 20px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    background-color: #ffffff;\r\n    /* box-shadow: 2px 2px 12px rgb(180 180 180 / 64%); */\r\n\r\n}\r\n\r\n.MessagePageContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    background-color: #f1f7ff;\r\n\r\n}\r\n\r\n.newMsg-Btn {\r\n    margin: 20px;\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    transition: 0.5s;\r\n    background-size: 200% auto;\r\n    border-radius: 10px;\r\n    color: white;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    border: none;\r\n    width: 10%;\r\n    font-weight: 500;\r\n    font-size: 10pt;\r\n    color: #ffffff;\r\n}\r\n\r\n.newMsgSubmit-Btn {\r\n    margin: 20px;\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    transition: 0.5s;\r\n    background-size: 200% auto;\r\n    border-radius: 10px;\r\n    color: white;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    border: none;\r\n    width: 30%;\r\n    font-weight: 500;\r\n    font-size: 10pt;\r\n    color: #ffffff;\r\n}\r\n\r\n.message-modal {\r\n    background-color: #ffffff;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 40%;\r\n    border-radius: 20px;\r\n    box-shadow: 2px 2px 12px rgb(180 180 180 / 64%);\r\n\r\n}\r\n\r\n.message-modal-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.messagesIcons {\r\n    display: flex;\r\n}\r\n\r\n.messagesActions {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n}\r\n\r\n.action-btn {\r\n    margin: 8px;\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    text-align: center;\r\n    background-size: 200% auto;\r\n    border-radius: 100px;\r\n    border: none;\r\n    color: white;\r\n    padding: 11px;\r\n    font-weight: 500;\r\n    font-size: 10pt;\r\n\r\n\r\n}\r\n\r\n.messageActivity-btn {\r\n    margin: 8px;\r\n    text-align: center;\r\n    background-color: white;\r\n    border-radius: 100px;\r\n    border: 1px solid #3762f0;\r\n    padding: 11px;\r\n    font-weight: 500;\r\n    font-size: 10pt;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.messageActivity-btn:hover {\r\n\r\n    background-color: rgb(239, 239, 255);\r\n\r\n\r\n}\r\n\r\n.action-btn {\r\n    border-radius: 100px;\r\n    padding: 9px;\r\n\r\n}\r\n\r\n.form-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.messageContent {\r\n    margin-bottom: 20px;\r\n    background-color: #f1f1f1;\r\n    padding: 20px;\r\n    width: 80%;\r\n    height: 80%;\r\n    border-radius: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n\r\n}\r\n\r\n.allMessagesContainer {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 80%;\r\n    width: 80%;\r\n\r\n}\r\n\r\n.chooseActivity {\r\n    margin: 5px;\r\n}\r\n\r\n.chooseActivityCont {\r\n    margin: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: row-reverse;\r\n}\r\n\r\n.chooseActivityCont div {\r\n    margin: 10px;\r\n\r\n}\r\n\r\n.close:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n.updateBtnsContainer {\r\n    display: flex;\r\n}\r\n\r\n.updateBtns {\r\n    background-color: white;\r\n    border: 1px solid #3762f0;\r\n    padding: 7px;\r\n    border-radius: 100px;\r\n    margin: 10px;\r\n    width:120px;\r\n}\r\n\r\n.messageContentInput {\r\n    margin-bottom: 20px;\r\n    background-color: #ffffff;\r\n    padding: 20px;\r\n    width: 100%;\r\n    height: 80%;\r\n    border-radius: 20px;\r\n    display: flex;\r\n    border: none;\r\n}\r\n\r\n.titleAndNewMessage{\r\n    margin-top: 7%;\r\n    width: 100%;\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
